import { useCallback } from 'react';
import { useNavigate } from 'react-router';
import { ContactVerificationSuccessAction } from '@/components/ModalRenderer/components/SE/contactVerificationSuccess';
import useWithdrawAccess from '@/pages/Credit/SE/hooks/useWithdrawAccess/useWithdrawAccess';
import { routeMap } from '@/routes/routeMap';
import { assertUnreachable } from '@/utils/typescript';

const useOnContactVerificationSuccess = (successAction: ContactVerificationSuccessAction) => {
  const navigate = useNavigate();
  const { attemptWithdrawNavigation } = useWithdrawAccess();

  return useCallback(() => {
    switch (successAction) {
      case ContactVerificationSuccessAction.GoToProfile:
        void navigate(routeMap.userProfile.root);
        break;
      case ContactVerificationSuccessAction.ResumeWithdraw:
        attemptWithdrawNavigation();
        break;
      default:
        assertUnreachable(successAction);
    }
  }, [attemptWithdrawNavigation, navigate, successAction]);
};

export default useOnContactVerificationSuccess;
